import { Flex } from "Element/Flex";
import styled from "styled-components";
import { StyledHeroText } from "../styled";
export const ParticleContainer = styled.div`
  canvas {
    position: relative !important;
  }
`;

export const HeroTextWrapper = styled.div`
  position: relative;
  padding-bottom: 36px;
`;

export const HeroTextShadow = styled(StyledHeroText)`
  position: absolute;
  color: #fff;
  margin: 0;
  top: 0px;
  z-index: 0;
  width: 100%;
  -webkit-text-stroke-width: 16px;
  -webkit-text-stroke-color: white;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    -webkit-text-stroke-width: 10px;
  `}
`;

export const ButtonWrapper = styled(Flex)`
  button:first-child {
    margin-right: 36px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    button:first-child {
      margin-bottom: 16px;
    }
  `}
`;

export const HeroWrapper = styled.div`
  display: block;
  margin: 16px;
`;
